<template>
  <div v-if="total > 0" class="sticky grid grid-cols-2 top-36">
    <div class="flex flex-col justify-center">
      <p class="text-6xl font-bold leading-none font-display">
        {{ average.toFixed(1) }}
      </p>
      <div class="flex items-center">
        <Icon
          v-for="(icon, index) in icons"
          :key="`star-${index}`"
          :name="icon"
          class="block w-6 h-6 text-warning-400"
        />
      </div>
      <p class="mt-1 text-xs text-gray-500">Based on {{ total }} ratings</p>
    </div>
    <ul class="space-y-2">
      <li
        v-for="(item, index) in counts"
        :key="`count-${index}`"
        class="flex items-center"
      >
        <p class="text-xs">{{ item.value }} Star</p>
        <p
          class="relative flex-grow h-3 overflow-hidden bg-gray-200 dark:bg-gray-700 rounded-3xl ms-2"
        >
          <span
            class="absolute top-0 bottom-0 left-0 block rounded-3xl bg-primary-500"
            :style="{ width: item.percentage + '%' }"
          ></span>
        </p>
      </li>
    </ul>
  </div>
  <div v-else>
    <Icon
      name="MdiStarBoxMultipleOutline"
      class="block w-24 h-24 text-warning-400"
    />
    <p class="mt-2 text-3xl font-bold leading-tight font-display">
      {{ $t("no_reviews") }}
    </p>
    <p class="text-sm text-gray-500">{{ $t("first_to_review") }}</p>
  </div>
</template>

<script>
import { useProductStore } from "@/store/product.js";
const iconNames = {
  empty: "MdiStarOutline",
  half: "MdiStarHalfFull",
  full: "MdiStar",
};

export default {
  setup() {
    const productStore = useProductStore();
    const average = computed(() => productStore.averageRating);
    const stars = computed(() => productStore.ratingStars);
    const counts = computed(() => productStore.ratingCounts);
    const total = computed(() => productStore.totalRatings);

    return { average, stars, counts, total };
  },
  computed: {
    icons() {
      return this.stars.map((item) => iconNames[item]);
    },
  },
};
</script>
